import { Route, Switch, useRouteMatch } from "react-router-dom";
import SettingsClientsList from "./clients/SettingsClientsList";
import SettingsClientCreateEditor from "./clients/SettingsClientCreateEditor";
import SettingsClientEditor from "./clients/SettingsClientEditor";

const SettingsClients = ({ token, API }) => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path}>
        <SettingsClientsList token={token} API={API} basePath={path} />
      </Route>
      <Route exact path={`${path}/new`}>
        <SettingsClientCreateEditor token={token} basePath={path} />
      </Route>
      <Route path={`${path}/:id`}>
        <SettingsClientEditor token={token} />
      </Route>
    </Switch>
  );
};

export default SettingsClients;
